/**
 * 时间戳转换,支持数字和字符串类型时间戳
 */
export function convertTime(timestamp) {
  if (timestamp) {
    var reg = /^\d+$/;
    if (typeof timestamp === "number" || reg.test(timestamp)) {
      var n = timestamp * 1000;
      var date = new Date(n);
      var Y = date.getFullYear() + "-";
      var M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      var D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      var h =
        date.getHours() < 10
          ? "0" + date.getHours() + ":"
          : date.getHours() + ":";
      var m =
        date.getMinutes() < 10
          ? "0" + date.getMinutes() + ":"
          : date.getMinutes() + ":";
      var s =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return Y + M + D + " " + h + m + s;
    }
    return "时间格式错误";
  }
  return "";
}

// 判断是否是移动端
export const isMobile = () => {
  return !!navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i);
};

// 去除文生图的多余参数
export const removeOptions = (str) => {
  const regexList = [
    /--ar\s\d+:\d+/g, // 匹配 --ar 3:4 或类似格式
    // /--s\s\d+/g, // 匹配 --s 750 或类似格式
    // /--v\s\d+/g, // 匹配 --v 5 或类似格式
  ];

  let result = str;
  regexList.forEach((regex) => {
    result = result.replace(regex, "");
  });

  return result.trim();
};

// 浅复制
export function copy(obj) {
  // 基本类型和函数直接返回
  if (!(obj instanceof Object) || typeof obj === "function") {
    return obj;
  }
  const newObj = {};
  // eslint-disable-next-line no-restricted-syntax
  for (const p in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, p)) {
      newObj[p] = obj[p];
    }
  }
  return newObj;
}

// 生成随机数
export const randomNum = (minNum = 0, maxNum) => {
  return Math.floor(Math.random() * maxNum) + minNum;
};

/**图片base64转文件流 */
export const base64ToFile = (
  base64,
  type = "image/png",
  filename = new Date().getTime() + "image.png"
) => {
  // 将Base64编码分割成数据类型和数据内容
  const splitted = base64.split(",");
  // const dataType = splitted[0].match(/:(.*?);/)[1];
  const byteCharacters = atob(splitted[1]);
  const byteLength = byteCharacters.length;
  const byteArrays = new Uint8Array(byteLength);

  // 将Base64数据转换为字节数组
  for (let i = 0; i < byteLength; i++) {
    byteArrays[i] = byteCharacters.charCodeAt(i);
  }

  // 创建文件对象并返回
  return new File([byteArrays], filename, {
    type: type,
  });
};

export function imageToBase64(imageUrl) {
  return new Promise((resolve, reject) => {
    const image = new Image();

    image.onload = function () {
      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d");

      canvas.width = image.width;
      canvas.height = image.height;

      context.drawImage(image, 0, 0, image.width, image.height);

      try {
        const base64DataUrl = canvas.toDataURL("image/png");
        resolve(base64DataUrl);
      } catch (error) {
        reject(error);
      }
    };

    image.onerror = function (error) {
      reject(error);
    };
    image.crossOrigin = "Anonymous";
    image.src = imageUrl;
  });
}

// 图片地址转file文件
export const imageUrlToFile = (url) => {
  return new Promise((resolve, reject) => {
    const image = new Image();

    image.onload = function () {
      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d");

      canvas.width = image.width;
      canvas.height = image.height;

      context.drawImage(image, 0, 0, image.width, image.height);

      try {
        canvas.toBlob((blob) => {
          resolve(blob);
        }, "image/png");
      } catch (error) {
        reject(error);
      }
    };

    image.onerror = function (error) {
      reject(error);
    };
    image.crossOrigin = "Anonymous";
    image.src = url;
  });
};
